angular.module('unergie.main')
.controller('newComplaintModalCtrl', ($scope, $filter, $uibModalInstance, JiraService, ApiAdmin, ErrorCatcher, AlertManager, AuthService, FileUploader, BoFeaturesService, contractElec) => {
    $scope.isComplaintsFeatureOn = (feature) => BoFeaturesService.getModuleFeatures('complaints')[feature]
    $scope.fetchCategories = () => {
        $scope.loadingDropdown = true
        return ApiAdmin.getDropdownChoices({ project: 'complaints', field: 'complaintType' }).$promise
        .then((categories) => {
            $scope.categories = categories
            $scope.loadingDropdown = false
        })
        .catch(ErrorCatcher)
    }

    $scope.fetchCategories()

    $scope.attachmentUploader = new FileUploader({
        method: 'POST',
        autoUpload: false,
        onErrorItem(item, response, status, headers) {
            return ErrorCatcher(response)
        },
        onCompleteAll() {
            AlertManager.success('Pièces jointes enregistrées.')
            $scope.close()
            $scope.saving = false
        },
    })

    $scope.newComplaint = {}

    if ($scope.isComplaintsFeatureOn('mustChooseComplaintLevel')) {
        $scope.levels = ['N1', 'N2']
        $scope.newComplaint.level = 'N1'
    } else {
        $scope.levels = ['N0']
        $scope.newComplaint.level = 'N0'
    }

    $scope.canCreate = () => {
        return ($scope.newComplaint.summary
            && $scope.newComplaint.description
            && $scope.newComplaint.category
        )
    }

    $scope.confirmComplaintSubmit = () => {
        $scope.saving = true
        const jiraIssue = {
            summary: $scope.newComplaint.summary,
            description: $scope.newComplaint.description,
            enrichSummary: false,
            idContract: contractElec.id,
            isDraft: contractElec.simple_status ? ['DRAFT'].includes(contractElec.simple_status) : false,
            complaintType: $scope.newComplaint.category,
            complaintLevel: { value: $scope.newComplaint.level },
        }

        return ApiAdmin.createJiraIssue({ projectKey: 'complaints' }, jiraIssue).$promise
        .then((issue) => {
            if ($scope.isComplaintsFeatureOn('bypassValidation')) {
                return ApiAdmin.performIssueTransition({ idIssue: issue.issueId, issueType: 'complaint' }, { id: '311' }).$promise
                .then(() => {
                    return issue
                })
            }
            return issue
        })
        .then((issue) => {
            if ($scope.attachmentUploader.queue.length > 0) {
                AlertManager.success('Réclamation créée, tranfert des pièces jointes...')
                $scope.attachmentUploader.queue.forEach((file) => {
                    file.url = `/api-admin/jira/servicedesk/project/complaints/issue/${issue.issueId}/add/file`
                    file.formData = [{ isPublic: true }]
                })
                $scope.attachmentUploader.uploadAll()
            } else {
                AlertManager.success('Réclamation créée.')
                $scope.close()
                $scope.saving = false
            }
        })
        .catch((err) => {
            AlertManager.error(`Une erreur est survenue lors de l'appel a JIRA ${err.data && `: ${err.data.message}`}`, 5000)
        })
    }

    // RETURN OK
    $scope.close = () => $uibModalInstance.close()
})
